import { format } from "date-fns";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export function capitalize(name = '') {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
  
export   const maskIndianPhoneNumber = (number) => {
    if (!number || number.length < 10) return number;
    return number.replace(/(\d{5})(\d{5})/, "$1 $2");
  };

  export const convertToNumberIds = (idValue) => {
    // If it's an array, convert each element to number
    if (Array.isArray(idValue)) {
      return idValue.map(id => Number(id));
    }
    // If it's a string with "#" delimiters, split and convert each to number
    else if (typeof idValue === 'string' && idValue.includes('#')) {
      return idValue.split('#').map(id => Number(id));
    }
    // If it's a simple string, convert to number
    else if (idValue !== undefined && idValue !== null) {
      return Number(idValue);
    }
    // Default case: return empty array
    return [];
  };
  

  export   const getBadgeColor = (status) => {
    switch (status?.toLowerCase()) {
      case "assigned":
        return "bg-warning";
      case "resolved":
        return "bg-success";
      case "pending":
        return "bg-danger";
      default:
        return "bg-info";
    }
  };


  export const getDeviceIcon = (os) => {
    if (!os) return "mdi-laptop";
    const osLower = os.toLowerCase();
    if (osLower.includes("ios") || osLower.includes("iphone") || osLower.includes("ipad")) {
      return "mdi-apple";
    } else if (osLower.includes("android")) {
      return "mdi-android";
    } else if (osLower.includes("windows")) {
      return "mdi-microsoft-windows";
    } else {
      return "mdi-laptop";
    }
  };

  export const getStatusBadge = (status) => {
    if (!status) return "secondary";
    switch (status.toLowerCase()) {
      case "on": return "success";
      case "off": return "danger";
      case "open": return "info";
      case "in progress": return "warning";
      case "resolved": return "success";
      case "closed": return "secondary";
      default: return "secondary";
    }
  };


  // Export to Excel helper
 export  function exportToExcel(data) {
    const ws = XLSX.utils.json_to_sheet(data.map(u => ({
      Name: `${u.firstName} ${u.lastName}`,
      Email: u.email,
      Contact: u.contactNumber,
      Latitude: u.currentLocation?.latitude ?? "",
      Longitude: u.currentLocation?.longitude ?? "",  
 
  "Check-In": u.checkIn ? "Yes" : "No",
  Date: u.Timestamp ? new Date(u.Timestamp).toLocaleDateString('en-CA') : "", // YYYY-MM-DD
  Time: u.Timestamp
    ? new Date(u.Timestamp).toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
    : ""

    })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CheckIns");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const today = new Date().toISOString().split("T")[0];

  saveAs(new Blob([wbout], { type: "application/octet-stream" }), `checkins_${today}.xlsx`);
  }

  export   const getCheckInDates = (checkInData) => {
    
    if (!checkInData || !checkInData.result) return {};
    const map = {};
    checkInData.result.forEach((item) => {
      // DateTime is in YYYYMMDD
      const y = item.DateTime.slice(0, 4);
      const m = item.DateTime.slice(4, 6);
      const d = item.DateTime.slice(6, 8);
      const dateStr = `${y}-${m}-${d}`;
      map[dateStr] = item.checkIn;
    });
    return map;
  };


  export const checkFilterMatch = (filterValue, userValue) => {
    // Return true if no filter applied or filter is "0"
    if (!filterValue || filterValue === "0") return true;
    
    // Convert user value to array (handles complex user value types)
    let userArray;
    if (typeof userValue === 'string') {
      // Handle string formats like "3", "3#4", "4,5"
      userArray = userValue.includes('#') 
        ? userValue.split('#') 
        : userValue.includes(',')
        ? userValue.split(',')
        : [userValue];
    } else if (Array.isArray(userValue)) {
      userArray = userValue;
    } else {
      userArray = [String(userValue)];
    }
    
    // Convert filter to array for consistent comparison
    let filterArray;
    if (typeof filterValue === 'string') {
      filterArray = filterValue.includes('#') 
        ? filterValue.split('#') 
        : filterValue.includes(',')
        ? filterValue.split(',')
        : [filterValue];
    } else if (Array.isArray(filterValue)) {
      filterArray = filterValue;
    } else {
      filterArray = [String(filterValue)];
    }
    
    // Clean up arrays (trim whitespace and convert to strings)
    userArray = userArray.map(val => String(val).trim());
    filterArray = filterArray.map(val => String(val).trim());
    
    // Check if any user value matches any filter value
    return userArray.some(userVal => filterArray.includes(userVal));
  };


export const exportReportsToExcel = (filteredReports) => {
  const allowedIds = [
    "serialId",
    "incidentLocation",
    "incidentDate",
    "incidentTime",
    "compId",
  ];
  
  const excludedFields = [
    "isSOS",
    "ticketRangeAssigned",
    "ticketRoundAssigned",
    "compuArea",
    "count",
    "newCompN",
    "compArea",
    "userLocation",
    "reportedDate",
    "isUpdate",
    "isCreated",
    "updatedBy",
    "createdBy",
    "createdAt",
    "oldCompN",
    "updatedAt",
    "notArea",
    "audio",
    "time",
    "distance",
    "regionName",
    "assignedRoundUser",
    "roundOfficerAssigned",
    "assignedRangeUser",
    "WorkingAt",
    "WorkingBy",
    "AssignedAt",
    "AssignedBy",
    "ResolvedAt",
    "ResolvedBy",
    "ClosedAt",
    "ClosedBy",
    "regionId#roleId#userId",
    "regionId#incidentType#ticketId",
    "ticketId",
    "id",
    "rangeId",
    "roundId",
    "beatId",
    "divisionId",
    "incidentTypeId",
    "deviceInfo"
  ];
  
  // Define the exact sequence you want for columns
  const preferredOrder = [
    "serialId",
    "compId", 
    "divisionName",
    "rangeName",
    "roundName",
    "beatName",
    "description",
    "address",
    "porNumber",
    "fireCount",
    "burnedArea",
    "fsiFeedback",
    "fireExtinguishedDate",
    "fireExtinguishedTime",
    "assignedUsers",
    "resolvedByUser",
    "status",
    "callerPhone",
    "callerName",
    "killedAnimal",
    "killedByWildAnimal",
    "typeofIncident", // Make sure this is included
    "animalOwnerName",
    "remark",
    "latitude",        
    "longitude",       
    "incidentDate",
    "incidentTime",
    "media"
  ];

  const mediaPrefix = process.env.REACT_APP_ASSETURL;

  // Helper function to check if field should be excluded
  const shouldExcludeField = (key) => {
    // Exclude fields that end with "At" or "By" (but allow exceptions in allowedIds)
    if ((key.endsWith('At') || key.endsWith('By')) && !allowedIds.includes(key)) {
      return true;
    }
    // Exclude fields in excludedFields list
    if (excludedFields.includes(key)) {
      return true;
    }
    // Exclude ID fields (except allowed ones) - be more specific
    if ((key.toLowerCase().endsWith("id") || key.toLowerCase().includes("id")) && !allowedIds.includes(key)) {
      return true;
    }
    // Exclude complex objects like assignedUser, assignedRangeUser arrays
    if (typeof key === 'string' && (key.includes('assignedUser') || key.includes('assignedRangeUser')) && key !== 'assignedUsers') {
      return true;
    }
    return false;
  };

  // Helper function to process field values consistently
  const processFieldValue = (key, value) => {
   
    // Handle media arrays - create separate clickable URLs
    if (key === "media" && Array.isArray(value)) {
      if (value.length === 0) return "";
      // Create individual hyperlinks for each media file
      return value.map((item, index) => {
        const fullUrl = mediaPrefix + "/" + item;
        return `Media ${index + 1}: ${fullUrl}`;
      }).join("\n");
    } 
    // Handle assigned users - extract names properly
    else if (key === "assignedUsers" && typeof value === "string") {
      return value;
    }
    // Handle date fields
    else if ((key === "fireExtinguishedDate" || key === "incidentDate" ||key === "damageDate" || key ==="panchanamaDate") && value) {
      const timestamp = Number(value);
      if (!isNaN(timestamp)) {
        return format(new Date(timestamp), "yyyy-MM-dd");
      }
      return value;
    } 
    // Handle time fields
    else if ((key === "fireExtinguishedTime" || key === "incidentTime"|| key === "damageTime") && value) {
      const timestamp = Number(value);
      if (!isNaN(timestamp)) {
        return format(new Date(timestamp), "HH:mm");
      }
      return value;
    }
    // Handle typeofIncident field - format for better display
    else if (key == "typeofIncident" && value) {
      // Convert common values to more readable format
    
      return value;
    }
    // Handle arrays that should be comma-separated
    else if (Array.isArray(value) && key !== "media") {
      return value.join(", ");
    }
    // Handle null/undefined values
    else if (value === null || value === undefined|| value ==="") {
      return "";
    }

    return value;
  };

  const sanitizedData = filteredReports.map((report) => {
    const sanitized = {};
    const addedKeys = new Set();
    for (const key of preferredOrder) {
      if (key in report && !shouldExcludeField(key) && !addedKeys.has(key)) {
        sanitized[key] = processFieldValue(key, report[key]);
        addedKeys.add(key);
      }
    }
    
    if (report.incidentLocation && typeof report.incidentLocation === "object") {
      if ("lat" in report.incidentLocation) {
        sanitized.latitude = report.incidentLocation.lat;
        addedKeys.add("latitude");
      }
      if ("long" in report.incidentLocation) {
        sanitized.longitude = report.incidentLocation.long;
        addedKeys.add("longitude");
      }
    } else if (report.incidentLocation && typeof report.incidentLocation === "string") {
      sanitized.incidentLocationText = report.incidentLocation;
      addedKeys.add("incidentLocationText");
    }

    Object.entries(report).forEach(([key, value]) => {
      if (
        key !== "incidentLocation" && 
        !shouldExcludeField(key) &&
        !addedKeys.has(key)
      ) {
        sanitized[key] = processFieldValue(key, value);
        addedKeys.add(key);
      }
    });

    return sanitized;
  });


  // Create worksheet from the data
  const worksheet = XLSX.utils.json_to_sheet(sanitizedData);

  // Replace headers with formatted equivalents
  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  const headers = [];

  // Get all header cells
  for (let C = range.s.c; C <= range.e.c; C++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
    if (worksheet[cellAddress]) {
      const englishHeader = worksheet[cellAddress].v;
      headers.push({ address: cellAddress, english: englishHeader });
    }
  }

  function formatHeader(header) {
    let formatted = header
      .replace(/\./g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2");
    formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());
    
    // Special cases for better header names
    const headerMappings = {
      "Serial Id": "Ticket Id",
      "Comp Id": "Compartment Id",
      "Division Name": "Division Name",
      "Range Name": "Range Name", 
      "Round Name": "Round Name",
      "Beat Name": "Beat Name",
      "Fire Count": "Fire Count",
      "Burned Area": "Burned Area (Hectares)",
      "Fsi Feedback": "FSI Feedback",
      "Fire Extinguished Date": "Fire Extinguished Date",
      "Fire Extinguished Time": "Fire Extinguished Time",
      "Assigned Users": "Assigned Users",
      "Resolved By User": "Resolved By User",
      "Caller Phone": "Caller Phone",
      "Caller Name": "Caller Name",
      "Killed Animal": "Killed Animal",
      "Killed By Wild Animal": "Killed By Wild Animal", 
      "Animal Owner Name": "Animal Owner Name",
      "Typeof Incident": "Death/Injured", // Changed header name as requested
      "Incident Date": "Incident Date",
      "Incident Time": "Incident Time",
      "Media": "Media Files"
    };

    return headerMappings[formatted] || formatted;
  }

  // Apply header formatting
  headers.forEach((header) => {
    worksheet[header.address].v = formatHeader(header.english);
  });

  // Set column widths for better readability
  const columnWidths = [];
  for (let C = range.s.c; C <= range.e.c; C++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
    const headerText = worksheet[cellAddress]?.v || "";
    
    // Set specific widths for certain columns
    if (headerText.includes("Media")) {
      columnWidths.push({ wch: 50 }); // Wide column for media URLs
    } else if (headerText.includes("Description") || headerText.includes("Remark")) {
      columnWidths.push({ wch: 40 }); // Wide for text content
    } else if (headerText.includes("Address")) {
      columnWidths.push({ wch: 35 }); // Wide for addresses
    } else if (headerText.includes("Date") || headerText.includes("Time")) {
      columnWidths.push({ wch: 15 }); // Standard width for dates/times
    } else if (headerText.includes("Death/Injured")) {
      columnWidths.push({ wch: 15 }); // Standard width for incident type
    } else {
      columnWidths.push({ wch: 20 }); // Default width
    }
  }
  worksheet['!cols'] = columnWidths;

  // Enable text wrapping for cells with line breaks
  for (let R = range.s.r; R <= range.e.r; R++) {
    for (let C = range.s.c; C <= range.e.c; C++) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      if (worksheet[cellAddress] && typeof worksheet[cellAddress].v === 'string' && worksheet[cellAddress].v.includes('\n')) {
        if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
        worksheet[cellAddress].s.alignment = { wrapText: true, vertical: 'top' };
      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Reports");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `Reports_${format(new Date(), "yyyy-MM-dd")}.xlsx`;
  link.click();

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    link.remove();
  }, 100);
};